import React, { useCallback, useEffect, useState } from "react";
import { CircularProgress, Grid, Typography } from "@mui/material";
import { StyleButtonLarge, StyleModal } from "../../assets/js/Theme";
import { injectIntl } from "react-intl";
import OtpInput from "react-otp-input";
import SvgIcon from "../../components/SvgIcon";

function OtpVerification(props) {
  const { intl, showOtp, generateOtp, verifyOtp, closeOtpModal, showError, generateOtpLoading } = props;
  const [otpValue, setOtpValue] = useState("");
  const [loading, setLoading] = useState(false);
  // const [showResend, setShowResend] = useState(false);
  // console.log('showResend', showResend);
  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     !showResend && console.log('show resend');

  //     !showResend && setShowResend(true)
      
  //   }, 5000);
  //   return () => clearTimeout(timer);
  // }, [showResend]);
  useEffect(() => {
    showOtp && resetTimer()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showOtp])
  const delay = 60;

  const [timer, setTimer] = useState(delay);
  const timeOutCallback = useCallback(() => setTimer(currTimer => currTimer > 0 && currTimer - 1), []);

  useEffect(() => {
    timer > 0 && setTimeout(timeOutCallback, 1000);
  }, [timer, timeOutCallback]);

  const resetTimer = function () {
    if (timer <= 0) {
      setTimer(delay);
    }
  };

  const _verifyOtp = () => {
    setLoading(true);
    verifyOtp(otpValue)
      .then((status) => {
        !status && setLoading(false);
        setOtpValue("");
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    otpValue.length === 4 && _verifyOtp();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [otpValue]);
  return (
    <>
      <StyleModal
        open={showOtp}
        onClose={closeOtpModal}
        className="modal--wrapper"
      >
        <div className="modal--block modal-size-sm">
          <Grid container alignItems="center" className="modal--header">
            <Grid item xs={10}>
              <Typography color="primary" variant="h4">
                {intl.formatMessage({
                  id: "VALIDATION.ENTER_VERIFICATION_CODE",
                })}
              </Typography>
            </Grid>
            <Grid item xs={2} align="right">
              <StyleButtonLarge onClick={closeOtpModal}>
                <SvgIcon name="cross" />
              </StyleButtonLarge>
            </Grid>
          </Grid>
          <div className="modal--content--wrapper otp-wrapper">
            <Grid item xs={12} className="form-group">
              {!generateOtpLoading && <Typography paragraph color="primary">
                {intl.formatMessage({ id: "OTP.VERIFICATION_CODE" })}
              </Typography>}
              {showError && <Typography paragraph color="error" align="center">
                {intl.formatMessage({ id: "GENERAL.INVALID_OTP_CODE" })}
              </Typography>}
              <OtpInput
                value={otpValue}
                onChange={(value) => {
                  setOtpValue(value);
                  // value.length === 4 && _verifyOtp();
                }}
                numInputs={4}
                isInputNum
                // shouldAutoFocus
                hasErrored={showError}
                errorStyle='error--input'
              />
              
              <Typography align="right" color="primary" variant="body1">
                {intl.formatMessage({
                  id: "VALIDATION.NOT_RECEIVED_CODE",
                })}
                {parseInt(timer) < 1 ? <Typography
                  color="error"
                  className="link"
                  component="span"
                  onClick={() => {
                    resetTimer()
                    generateOtp()
                  }}
                  variant="body1"
                >
                {intl.formatMessage({ id: "RE_SEND" })}
                </Typography>:<span>{`wait for ${timer} sec`}</span>}
              </Typography>
            </Grid>
            <Grid item xs={12} md={12}>
              <Grid
                container
                spacing={3}
                className="button--wrapper"
                justifyContent="flex-end"
              >
                <Grid item xs={12}>
                  <StyleButtonLarge
                    disabled={otpValue.length < 4}
                    variant="contained"
                    fullWidth
                    color="secondary"
                    size="large"
                    className="btn--wrapper"
                    onClick={_verifyOtp}
                  >
                    {intl.formatMessage({ id: "GENERAL.PROCEED" })}
                    {(loading || generateOtpLoading) && <CircularProgress color="primary" size={24} />}
                  </StyleButtonLarge>
                </Grid>
              </Grid>
            </Grid>
          </div>
        </div>
      </StyleModal>
    </>
  );
}

export default injectIntl(OtpVerification);
